import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.fund.member.sell');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-fund-member-sell',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.fund.member.sell/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminWidgetFundMemberSellComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund: any;

    public members: any = [];
    public investments: any = [];
    public settlementRounds: number = 3;
    public roundDates: string[] = [];

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { data } = await wiz.call("list", { id: this.fund.id });
        this.members = data.members;
        this.investments = data.investments;

        let maxRounds = 3;

        for (let i = 0; i < this.members.length; i++) {
            let member: any = this.members[i];
            if (!member.extra.sell) member.extra.sell = {};
            if (!member.extra.buy) member.extra.buy = {};
            if (!member.extra.sell_note) member.extra.sell_note = {};

            for (let j = 0; j < this.investments.length; j++) {
                let invest: any = this.investments[j];
                member.extra.buy[invest.id] = this.calcBuyAmount(member, invest);
                if (!member.extra.sell[invest.id]) {
                    member.extra.sell[invest.id] = [];
                }
                if (!member.extra.sell_note[invest.id]) {
                    member.extra.sell_note[invest.id] = '';
                }
                let existingLen = member.extra.sell[invest.id].length;
                if (existingLen > maxRounds) {
                    maxRounds = existingLen;
                }
            }
        }

        this.settlementRounds = maxRounds;
        this.initRoundDates();
        this.padSellArrays();
        await this.service.render();
    }

    public calcBuyAmount(member: any, invest: any): number {
        let memberContribution = Number(member.applied_amount) * Number(this.fund.amount_per_share);
        let investmentAmount = Number(invest.investment_amount);
        let totalAmount = Number(this.fund.total_amount);
        if (!totalAmount) return 0;
        return Math.floor(investmentAmount * memberContribution / totalAmount);
    }

    private initRoundDates() {
        this.roundDates = [];
        for (let i = 0; i < this.settlementRounds; i++) {
            let date = '';
            for (let member of this.members) {
                for (let invest of this.investments) {
                    let arr = member.extra.sell[invest.id];
                    if (arr && arr[i] && arr[i].date) {
                        date = arr[i].date;
                        break;
                    }
                }
                if (date) break;
            }
            this.roundDates.push(date);
        }
    }

    private syncRoundDatesToMembers() {
        for (let member of this.members) {
            for (let invest of this.investments) {
                let arr = member.extra.sell[invest.id];
                if (!arr) continue;
                for (let i = 0; i < this.settlementRounds; i++) {
                    if (arr[i]) arr[i].date = this.roundDates[i] || '';
                }
            }
        }
    }

    public async onRoundDateChange() {
        this.syncRoundDatesToMembers();
        await this.service.render();
    }

    private padSellArrays() {
        for (let member of this.members) {
            for (let invest of this.investments) {
                let arr = member.extra.sell[invest.id];
                if (!arr) {
                    member.extra.sell[invest.id] = [];
                    arr = member.extra.sell[invest.id];
                }
                while (arr.length < this.settlementRounds) {
                    arr.push({});
                }
            }
        }
    }

    public get roundIndices(): number[] {
        return Array.from({ length: this.settlementRounds }, (_, i) => i);
    }

    public async addSettlementRound() {
        this.settlementRounds++;
        this.roundDates.push('');
        this.padSellArrays();
        await this.service.render();
    }

    public async removeSettlementRound() {
        if (this.settlementRounds <= 1) return;
        this.settlementRounds--;
        this.roundDates.splice(this.settlementRounds);
        for (let member of this.members) {
            for (let invest of this.investments) {
                let arr = member.extra.sell[invest.id];
                if (arr && arr.length > this.settlementRounds) {
                    arr.splice(this.settlementRounds);
                }
            }
        }
        await this.service.render();
    }

    public async onSellAmountChange(member: any, investId: string, roundIndex: number) {
        const invest = this.investments.find((inv: any) => inv.id === investId);
        if (!invest) { await this.service.render(); return; }
        const buyAmount = this.calcBuyAmount(member, invest);
        const enteredAmount = member.extra.sell[investId][roundIndex].amount;
        for (let other of this.members) {
            if (other === member) continue;
            if (this.calcBuyAmount(other, invest) === buyAmount) {
                other.extra.sell[investId][roundIndex].amount = enteredAmount;
            }
        }
        await this.service.render();
    }

    public async update() {
        this.syncRoundDatesToMembers();
        const { code } = await wiz.call("update", { id: this.fund.id, data: JSON.stringify(this.members) });
        if (code == 200)
            await this.service.alert.success("저장되었습니다.");
        else
            await this.service.alert.error("오류가 발생했습니다.");
        await this.service.render();
    }

    public async alert(message: string, action: string = '확인', cancel: any = false, status: string = 'error') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public tab: any = 0;

    public async switchTab(tab: any) {
        this.tab = tab;
        await this.service.render();
    }

    public activeTab(tab: any) {
        if (this.tab == tab) return 'cursor-pointer rounded-md bg-zinc-100 px-3 py-2 text-sm font-medium text-zinc-800 flex items-center';
        return 'cursor-pointer rounded-md px-3 py-2 text-sm font-medium text-zinc-600 hover:text-zinc-800 flex items-center';
    }

    public sum(item) {
        let sum = 0;
        for (let i = 0; i < item.length; i++) {
            if (item[i].amount)
                sum = sum + item[i].amount * 1;
        }
        return sum;
    }

    public sumMember(mode = 'total', target: any = 0) {
        let sum = 0;
        for (let i = 0; i < this.members.length; i++) {
            let member = this.members[i];

            if (mode == 'total') {
                for (let investment in member.extra.sell) {
                    if (target == 'all') {
                        sum += this.sum(member.extra.sell[investment]);
                    } else if (member.extra.sell[investment][target] && member.extra.sell[investment][target].amount) {
                        sum += member.extra.sell[investment][target].amount * 1;
                    }
                }
            } else {
                if (member.extra.sell[mode]) {
                    if (target == 'all') {
                        sum += this.sum(member.extra.sell[mode]);
                    } else if (member.extra.sell[mode][target] && member.extra.sell[mode][target].amount) {
                        sum += member.extra.sell[mode][target].amount * 1;
                    }
                }
            }
        }
        return this.service.formatter.currency(sum);
    }

    public target_user: any = null;

    public async clickUser(user) {
        this.target_user = null;
        await this.service.render();
        this.target_user = user.id;
        await this.service.render();
    }

    public userEvent: any = {
        close: async () => {
            this.target_user = null;
            await this.service.render();
        }
    }

}

export default PortalLpsysadminWidgetFundMemberSellComponent;